
export const formatPrice = (amount = '0', currencyCode = 'AUD', currencySymbol = '$'): string => {
    const amountToFloat = parseFloat(amount);

    if (isNaN(amountToFloat)) {
        console.error(`wrong number format`);
        return `${currencyCode} ${currencySymbol}0.00`;
    }

    return `${currencyCode} ${currencySymbol}${amountToFloat.toFixed(2)}`;
};
